
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/[topic]/page/[page]",
      function () {
        return require("private-next-pages/resources/[topic]/page/[page].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/[topic]/page/[page]"])
      });
    }
  